//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'TaskItem',
  props: ['node', 'view'],

  data() {
    return {
      done: this.node.attrs.state === 'DONE'
    };
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/renderers/TaskItem.vue_rollup-plugin-vue=script.js